import styled from 'styled-components'

export const Container = styled.div``

export const ScoreCircleWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`

export const ScoreCircle = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  border: 5px solid ${({ $color }) => $color || 'var(--vo-danger)'};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ScoreCircleText = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: ${({ $color }) => $color || 'var(--vo-danger)'};
  margin: 0;
  white-space: nowrap;
`

export const RiskAlert = styled.div`
  background: var(--vo-danger-10);
  border: 1px solid var(--vo-danger-20);
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 20px;
`

export const RiskText = styled.p`
  margin: 0;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: var(--vo-danger);
  line-height: 1.6;
`

export const SectionTitle = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--vo-ink-2);
  margin: 0 0 10px;
`

export const DeficiencyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
`

export const DeficiencyItem = styled.div`
  background: var(--vo-danger-10);
  border-radius: 10px;
  padding: 12px 14px;
`

export const DeficiencyPrimary = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--vo-danger);
  margin: 0 0 3px;
`

export const DeficiencySecondary = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-slate);
  margin: 0;
`

export const FormLabel = styled.label`
  display: block;
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: var(--vo-ink-2);
  margin-bottom: 6px;
`

export const HelperText = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 11px;
  color: var(--vo-slate);
  margin: 4px 0 0;
`

export const SubmitBtn = styled.button`
  width: 100%;
  height: 48px;
  background: var(--vo-warning);
  color: white;
  border: none;
  border-radius: 10px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  &:hover { background: color-mix(in srgb, var(--vo-warning) 70%, black); }
  &:disabled { opacity: .5; cursor: not-allowed; }
`
